import moment from 'moment';

export default {
  methods: {
    ptosDuration(ptos, periodStartTime, periodEndTime, mode = 'day', where = null, ptoStartValue = null, ptoEndValue = null) {
      let totalDiff = 0;

      if (ptos && ptos.length > 0) {
        ptos.forEach((pto) => {
          if (!where || (where && where(pto))) {
            totalDiff += Math.abs(this.ptoDuration(pto, periodStartTime, periodEndTime, mode, ptoStartValue, ptoEndValue));
          }
        });
      }

      return totalDiff;
    },

    ptoDuration(pto, periodStartTime, periodEndTime, mode = 'day', ptoStartValue = null, ptoEndValue = null) {
      const startedAt = moment(ptoStartValue ? ptoStartValue(pto) : pto.starts_at);
      const stoppedAt = moment(ptoEndValue ? ptoEndValue(pto) : pto.ends_at);
      const ms = moment(stoppedAt).diff(moment(startedAt));
      return ms;
    },

  },
};



// WEBPACK FOOTER //
// ./src/store/modules/pto/mixins/duration.js